import PropTypes from 'prop-types';
import React from 'react';

const SearchFilter = (props) => (
	<div className="bsknacht17-filter">
		<input
			type="search"
			value={props.searchTerm || ''}
			placeholder="Suchen …"
			onFocus={props.handleFocus}
			onBlur={(e) => props.handleBlur(e.target.value)}
			onChange={(e) => props.setSearchTerm(e.target.value)}
		/>
	</div>
);

SearchFilter.propTypes = {
	handleFocus: PropTypes.func.isRequired,
	handleBlur: PropTypes.func.isRequired,
	setSearchTerm: PropTypes.func.isRequired,
	searchTerm: PropTypes.string,
};

export default SearchFilter;
